import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eab3c75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content h-[224px] px-[16px] text-Text/text_high text-[12px]" }
const _hoisted_2 = { class: "flex items-baseline" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grow" }, "Select time units", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-[16px] w-full" }, null, -1))
const _hoisted_5 = { class: "mt-[16px]" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Select a duration", -1))
const _hoisted_7 = { class: "mt-[16px] flex items-start flex-nowrap gap-[16px]" }
const _hoisted_8 = { class: "h-[40px]" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Apply")

import { computed, inject, onMounted, ref } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton, IncrediField, IncrediSelect, IncrediSlider } from 'incredi-ui';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { useWorkloadsTableUtils } from '@/views/workloads/workloads.utils';
import { onClickOutside } from '@vueuse/core';
import { isTargetPartOf } from '@/services/utils';
import { WORKLOADS_DURATION_UNITS } from '../../workloads.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'durationMenu',
  props: {
    unitSelection: null
  },
  emits: ["submit", "applyFilter", "closeMenu"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', value: { displayValue: string; unitSelection: WORKLOADS_DURATION_UNITS; filterValue: { from: number; to: number } }): void;
  (e: 'applyFilter', value: { from: number; to: number }): void;
  (e: 'closeMenu'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { unitSelection: WORKLOADS_DURATION_UNITS }

const { convertValueToCurrentUnitSelection } = useWorkloadsTableUtils();


const workloadsPageData = inject(IKWorkloadsPageData);


const timeUnitOptions = [WORKLOADS_DURATION_UNITS.Hours, WORKLOADS_DURATION_UNITS.Minutes, WORKLOADS_DURATION_UNITS.Seconds];
const timeUnit = ref<WORKLOADS_DURATION_UNITS>(props.unitSelection); // default option is in seconds

const menuRef = ref(null);
onClickOutside(menuRef, event => {
  // Using the 'as Event' to tell TypeScript we're sure it's an Event object
  const target = (event as Event).target as Node;
  // Check if the click target is a part of the duration menu
  // If the click originated from the duration menu, don't close the menu
  if (isTargetPartOf(target, ['incredi-menu-list-fragment--list', 'button--container'])) return;
  emit('closeMenu');
});

const convertSecondsToCurrentUnitSelection = (value: number) => {
  // seconds to hours
  if (timeUnit.value === WORKLOADS_DURATION_UNITS.Hours) {
    return Math.ceil(value / 3600);
  }
  // seconds to minutes
  if (timeUnit.value === WORKLOADS_DURATION_UNITS.Minutes) {
    return Math.ceil(value / 60);
  }
  return value;
};

const maxDurationNumberInitial = computed(() => convertValueToCurrentUnitSelection(WORKLOADS_DURATION_UNITS.Seconds, timeUnit.value, workloadsPageData?.workloadsDurationMaxNumber.value || 0));
const modelValueFromInitial = computed(() => convertSecondsToCurrentUnitSelection(workloadsPageData?.filter?.get?.value?.durationFrom || 0) || 0);
const modelValueToInitial = computed(() => convertSecondsToCurrentUnitSelection(workloadsPageData?.filter?.get?.value?.durationTo || 0) || 0);
const modelValueFrom = ref();
const modelValueTo = ref();
const maxDurationNumber = ref();

onMounted(() => {
  maxDurationNumber.value = maxDurationNumberInitial.value;
  modelValueFrom.value = modelValueFromInitial.value;
  modelValueTo.value = modelValueToInitial.value || maxDurationNumberInitial.value;
});

const sliderModel = computed(() => [modelValueFrom.value, modelValueTo.value]);

const chosenUnitShortFormat = computed(() => {
  switch (timeUnit.value) {
    case WORKLOADS_DURATION_UNITS.Minutes:
      return 'min';
    case WORKLOADS_DURATION_UNITS.Hours:
      return 'hr';
    case WORKLOADS_DURATION_UNITS.Seconds:
      return 'sec';
    default:
      return '';
  }
});

const handleDurationUpdate = () => {
  const from = convertValueToCurrentUnitSelection(timeUnit.value, WORKLOADS_DURATION_UNITS.Seconds, Number(modelValueFrom.value), false);
  const to = convertValueToCurrentUnitSelection(timeUnit.value, WORKLOADS_DURATION_UNITS.Seconds, Number(modelValueTo.value));

  if (from > to) {
    return;
  }

  emit('submit', {
    displayValue: `${modelValueFrom.value} - ${modelValueTo.value} ${chosenUnitShortFormat.value}`,
    unitSelection: timeUnit.value,
    filterValue: { from, to },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "menuRef",
        ref: menuRef,
        class: "menu--container mt-[4px]"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(IncrediSelect), {
              "model-value": timeUnit.value,
              items: timeUnitOptions,
              class: "mt-[8px] w-[136px]",
              size: "tiny",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (selection) => {
              modelValueFrom.value = _unref(convertValueToCurrentUnitSelection)(timeUnit.value, selection, modelValueFrom.value, false);
              modelValueTo.value = _unref(convertValueToCurrentUnitSelection)(timeUnit.value, selection, modelValueTo.value);
              maxDurationNumber.value = _unref(convertValueToCurrentUnitSelection)(timeUnit.value, selection, maxDurationNumber.value);
              timeUnit.value = selection;
            })
            }, null, 8, ["model-value"])
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(IncrediSlider), {
              "model-value": _unref(sliderModel),
              "show-label": false,
              class: "mt-[8px]",
              min: 0,
              max: maxDurationNumber.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = 
              newVal => {
                modelValueFrom.value = newVal[0];
                modelValueTo.value = newVal[1];
              }
            )
            }, null, 8, ["model-value", "max"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(IncrediField), {
                modelValue: modelValueFrom.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValueFrom).value = $event)),
                name: "durationFrom",
                "field-type": "number",
                label: "From",
                size: "big",
                maxlength: `${maxDurationNumber.value}`.length,
                onBlurWithin: _cache[3] || (_cache[3] = 
                () => {
                  if (Number(modelValueFrom.value) > Number(modelValueTo.value)) {
                    modelValueFrom.value = _unref(modelValueFromInitial);
                  }
                }
              )
              }, null, 8, ["modelValue", "maxlength"]),
              _createVNode(_unref(IncrediField), {
                modelValue: modelValueTo.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValueTo).value = $event)),
                name: "durationTo",
                "field-type": "number",
                label: "To",
                size: "big",
                maxlength: `${maxDurationNumber.value}`.length,
                onBlurWithin: _cache[5] || (_cache[5] = 
                () => {
                  if (Number(modelValueTo.value) > maxDurationNumber.value) {
                    modelValueTo.value = maxDurationNumber.value;
                    return;
                  }
                  if (Number(modelValueFrom.value) > Number(modelValueTo.value)) {
                    modelValueTo.value = maxDurationNumber.value;
                  }
                }
              )
              }, null, 8, ["modelValue", "maxlength"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_unref(IncrediButton), {
            size: "tiny",
            class: "mt-[4px] mr-[8px] float-right",
            design: "primary-green",
            onClick: _withModifiers(handleDurationUpdate, ["prevent"])
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 512)
    ]),
    _: 1
  }))
}
}

})